import { formatNumber } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppService, GRSSResponse, ValueIdPair } from 'src/app/_services/app.service';
import { ContributeTransactionalComponent } from '../contribute-transactional.component';

@Component({
    selector: 'app-contribute-edit',
    templateUrl: './contribute-edit.component.html',
    styleUrls: ['./contribute-edit.component.scss'],
    standalone: false
})
export class ContributeEditComponent implements OnInit {

  contribution: ContributeMarketRecordEdit;

  reasons: ValueIdPair[] = [];
  isReasonRequired: boolean = false;
  okClicked: Boolean = false;

  constructor(private translate: TranslateService, @Inject(LOCALE_ID) public localeID: string, public dialogRef: MatDialogRef<ContributeTransactionalComponent>, 
  @Inject(MAT_DIALOG_DATA) public data, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private service: AppService) { }

  ngOnInit() {
    this.InitializeVariables();
    this.calculateFSACOF();
  }

  InitializeVariables() {
    this.reasons = this.data.reasons;
    this.contribution = {
      defaultSpread:this.data.record.defaultSpread,
      spread: this.data.record.newSpread,
      rate: this.data.record.newRate,
      comments: this.data.record.comments,
      level: this.data.record.level,
      reasonId: this.data.record.listReasonId,
      fsaCOF: this.data.record.fsaCOF,
      response: null,
      marketId: this.data.marketId
    };
  }

  calculateFSACOF() {
    const defaultSpread = this.contribution.defaultSpread;
    this.http.post<ContributeMarketRecordEdit>(this.baseUrl + 'api/contribute/formatTransactNumbers', this.contribution).subscribe(result => {
      if (result.response.statusCode === 1) {
        let temp: string;
        let beforeDec;
        let afterDec;
  
        if (result.fsaCOF) {
          temp = result.fsaCOF.replace('-', '');
          if (!temp.includes('.')) {
            afterDec = 0;
            beforeDec = temp.length;
          } else {
            beforeDec = temp.split('.')[0].length.toString();
            afterDec = temp.split('.')[1].length.toString();
          }
          result.fsaCOF = formatNumber(Number(result.fsaCOF), this.localeID, beforeDec + '.' + afterDec + '-' + afterDec);
        }
  
        if (result.rate) {
          temp = result.rate.replace('-', '');
          if (!temp.includes('.')) {
            afterDec = 0;
            beforeDec = temp.length;
          } else {
            beforeDec = temp.split('.')[0].length.toString();
            afterDec = temp.split('.')[1].length.toString();
          }
          result.rate = formatNumber(Number(result.rate), this.localeID, beforeDec + '.' + afterDec + '-' + afterDec);
        }
  
        if (result.spread) {
          temp = result.spread.replace('-', '');
          if (!temp.includes('.')) {
            afterDec = 0;
            beforeDec = temp.length;
          } else {
            beforeDec = temp.split('.')[0].length.toString();
            afterDec = temp.split('.')[1].length.toString();
          }
          result.spread = formatNumber(Number(result.spread), this.localeID, beforeDec + '.' + afterDec + '-' + afterDec);
        }
  
        this.contribution = result;
        this.contribution.defaultSpread = defaultSpread;

        if (this.okClicked === true) {
          this.okClicked = false;
          let canProceed: boolean = false;
          if (this.contribution.rate && this.contribution.spread && this.contribution.defaultSpread) {
            if (this.contribution.spread !== this.contribution.defaultSpread) {
              if (this.contribution.reasonId) {
                canProceed = true;
              }
            } else {
              canProceed = true;
            }
          }
  
          if (canProceed === true) {
            this.dialogRef.close(this.contribution);
          }
        }
      } else {
        this.service.SaveStatus(false, this.translate.instant('Contribute.Messages.msgHeaderCont'), result.response.statusMessage, true);
      }
      
    }, error => {
      console.error(error);
    });
  }

  OnClickOk() {
    this.okClicked = true;
    this.calculateFSACOF();
  }

  
  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close(null);
  }

  /** Checks the spread and resets the reson code */
  checkSpread() {
    // Resetting the reason code
    if (Number(this.contribution.spread) == Number(this.contribution.defaultSpread)) {
      this.contribution.reasonId = '';
      this.isReasonRequired = false;
    } else {
      this.isReasonRequired = true;
    }
  }

}

/** An interface to access a record of a market contribution */
interface ContributeMarketRecordEdit {
  defaultSpread: string;
  spread: string;
  rate: string;
  fsaCOF: string;
  comments: string;
  level: number;
  reasonId: string;
  response: GRSSResponse;
  marketId: string;
}
